import createDictionnary from './createDictionnary';

const defaultDictionnary = createDictionnary([300, 400, 600, 900, 1024, 1200, 2000], 50);
const { getOptimalWidthAndHeight } = defaultDictionnary;

export { defaultDictionnary, getOptimalWidthAndHeight };
